module.exports = __webpack_public_path__ + "img/beliz_münster_bern_ocular.049c1fcc.jpg";